import React from "react";

interface LoadingButtonProps {
  text: string;
  loadingText?: string;
  loading?: boolean;
  onClick?: () => void;
  className?: string;
}

const LoadingButton: React.FC<LoadingButtonProps> = ({
  text,
  loadingText = "Loading...",
  loading = false,
  onClick,
  className = "",
}) => {
  return (
    <button
      onClick={onClick}
      disabled={loading}
      className={`
        ${loading ? "bg-gray-400 cursor-not-allowed" : "bg-orange-500 hover:bg-orange-600"}
        text-white font-semibold text-base sm:text-lg px-6 py-3 rounded-full 
        w-full mt-6 transition-all shadow-lg flex items-center justify-center
        ${className}
      `}
    >
      {loading ? (
        <>
          <svg
            className="animate-spin h-5 w-5 mr-2 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            ></path>
          </svg>
          {loadingText}
        </>
      ) : (
        text
      )}
    </button>
  );
};

export default LoadingButton;
